import { render, staticRenderFns } from "./CreditChangesTable.vue?vue&type=template&id=6a2c99e0&"
import script from "./CreditChangesTable.vue?vue&type=script&lang=js&"
export * from "./CreditChangesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports